import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=c312dbb8&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HomeDesktop.vue?vue&type=style&index=0&id=c312dbb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports